import React, { useState } from "react";
import "../styles/Gallery.css";

// Import images from carousel
import karigar from "../assets/karigar.jpg";
import darkImage from "../assets/dark.jpg";
import falseCeilingImage from "../assets/false_cieling.jpg";
import work from "../assets/work.jpg";
import bedroom2 from "../assets/bedroom2.jpg";
import office from "../assets/office.jpg";
import officeCeiling from "../assets/office_ceiling.jpg";
import publicImage from "../assets/public.jpg";
import background from "../assets/background.jpg";

function Gallery() {
  const [selectedImage, setSelectedImage] = useState(null);

  const galleryImages = [
    {
      id: 1,
      image: karigar,
      alt: "Karigar at Work",
      title: "Professional Craftmanship"
    },
    {
      id: 2,
      image: darkImage,
      alt: "Premium Dark Finishes",
      title: "Dark Elegance"
    },
    {
      id: 3,
      image: falseCeilingImage,
      alt: "False Ceiling Specialists",
      title: "False Ceiling Design"
    },
    {
      id: 4,
      image: work,
      alt: "Multiple Design Options",
      title: "Modern Workspace"
    },
    {
      id: 5,
      image: bedroom2,
      alt: "Modern Bedroom Designs",
      title: "Bedroom Interior"
    },
    {
      id: 6,
      image: office,
      alt: "Office Interiors",
      title: "Office Design"
    },
    {
      id: 7,
      image: officeCeiling,
      alt: "Office Ceiling Design",
      title: "Commercial Ceiling"
    },
    {
      id: 8,
      image: publicImage,
      alt: "Public Space Design",
      title: "Public Spaces"
    },
    {
      id: 9,
      image: background,
      alt: "Beautiful Interiors",
      title: "Interior Design"
    }
  ];

  const openModal = (image) => {
    setSelectedImage(image);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  return (
    <div className="gallery">
      <h1 className="galleryTitle">Our Gallery</h1>

      <div className="gallery-content">
        <p className="gallery-subtitle">Explore our collection of stunning interior designs and craftsmanship</p>

        <div className="gallery-grid">
        {galleryImages.map((item) => (
          <div 
            key={item.id} 
            className="gallery-tile"
            onClick={() => openModal(item)}
          >
            <img src={item.image} alt={item.alt} />
            <div className="gallery-tile-overlay">
              <h3>{item.title}</h3>
            </div>
          </div>
        ))}
      </div>
      </div>

      {/* Modal for enlarged image */}
      {selectedImage && (
        <div className="gallery-modal" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>&times;</button>
            <img src={selectedImage.image} alt={selectedImage.alt} />
            <h3 className="modal-title">{selectedImage.title}</h3>
          </div>
        </div>
      )}
    </div>
  );
}

export default Gallery;
